import React from "react";
import masterRoutes from "./masters/masterRoutes";

const configurationRoutes = [
    ...masterRoutes,
    {
        path: "/configuration/crewList/list",
        component: React.lazy(() => import("./crewList/CrewList")),
    },
    {
        path: "/configuration/crewList/:viewType/:id",
        component: React.lazy(() => import("./crewList/CrewFormDetails")),
    },
    {
        path: "/configuration/docRepo/list",
        component: React.lazy(() => import("./docRepo/DocRepoList")),
    },

    {
        path: "/configuration/docRepo/:viewType/:accnID",
        component: React.lazy(() => import("./docRepo/DocRepoFormDetails")),
    },
    {
        path: "/configuration/announcementType/list",
        component: React.lazy(() => import("./announcementType/AnnouncementTypeList")),
    },
    {
        path: "/configuration/announcementType/:viewType/:id?",
        component: React.lazy(() => import("./announcementType/AnnouncementTypeForm")),
    },
    {
        path: "/configuration/announcement/list",
        component: React.lazy(() => import("./announcement/AnnouncementList")),
    },
    {
        path: "/configuration/announcement/:viewType/:id?",
        component: React.lazy(() => import("./announcement/AnnouncementForm")),
    },
    {
        path: "/configuration/notification/preferences",
        component: React.lazy(() => import("../notification/notificationPreference/NotificationPreferenceForm")),
    },
    {
        path: "/association/agentAss/list",
        component: React.lazy(() => import("./association/agentAss/AgentAssList")),
    },

    {
        path: "/association/agentAss/:viewType/:agentTIN",
        component: React.lazy(() => import("./association/agentAss/AgentAssFormDetails")),
    },

    {
        path: "/manageUsers/user/list",
        component: React.lazy(() => import("./manageUsers/user/ManageUserList")),
    },
    {
        path: "/manageUsers/user/:viewType/:id",
        component: React.lazy(() => import("./manageUsers/user/ManageUserFormDetail")),
    },

    {
        path: "/manageAccount/user/:viewType/:id",
        component: React.lazy(() => import("./manageUsers/user/ManageUserFormDetail")),
    },

    // {
    //     path: "/manageAccount/:viewType/:id",
    //     component: React.lazy(() => import("./manageAccount/accountProfile/AccountProfileFormDetails")),
    // },
    {
        path: "/manageAccount/:viewType/:id",
        component: React.lazy(() => import("./manageAccount/accountProfile/AccountProfileFormDetails")),
    },
    {
        path: "/onboarding/:viewType/:regId",
        component: React.lazy(() => import("./manageAccount/onboarding/AccountOnboardingFormDetail")),
    },
    {
        path: "/onboarding/list",
        component: React.lazy(() => import("./manageAccount/onboarding/AccountOnboardingList")),
    },

    // update Password
    {
        path: "/manageUsers/updatePassword",
        component: React.lazy(() => import("./manageUsers/user/UpdatePasswordFormDetails")),
    },

    {
        path: "/payment/adviceGeneration/list",
        component: React.lazy(() => import("./payment/adviceGeneration/AdviceGenerationList")),
    },
    {
        path: "/payment/adviceGeneration/:viewType/:paymentRefNo",
        component: React.lazy(() => import("./payment/adviceGeneration/AdviceGenerationFormDetails")),
    },
    // {
    //     path: "/payment/recieptUpload/list",
    //     component: React.lazy(() => import("./payment/recieptUpload/ReceiptUploadList")),
    // },
    // {
    //     path: "/payment/recieptUpload/:viewType/:adviceRefNoNo",
    //     component: React.lazy(() => import("./payment/recieptUpload/ReceiptUploadFormDetails")),
    // },
    {
        path: "/recoveryApplicationConfig/list",
        component: React.lazy(() => import("./recoveryApplications/RecoveryApplicationList")),
    },
    {
        path: "/recoveryApplicationConfig/:viewType/:recId",
        component: React.lazy(() => import("./recoveryApplications/RecoveryApplicationFormDetails")),
    },

    {
        path: "/shipsBlacklist/list",
        component: React.lazy(() => import("./shipsBlacklist/ShipsBlacklistList")),
    },
    {
        path: "/shipsBlacklist/:viewType/:recId",
        component: React.lazy(() => import("./shipsBlacklist/ShipsBlacklistFormDetails")),
    },

    {
        path: "/applications/documentUpload/doc",
        component: React.lazy(() => import("./applications/uploadApp/UploadFormDetails")),
    },
    {
        path: "/applications/info/contact",
        component: React.lazy(() => import("../sessions/info/Contact")),
    },
    {
        path: "/applications/info/faq",
        component: React.lazy(() => import("../sessions/info/FAQ")),
    },

    {
        path: "/manageUsers/users/all/list",
        component: React.lazy(() => import("./manageUsers/user/ManageUserListAll")),
    },
    {
        path: "/manageAccounts/all/list",
        component: React.lazy(() => import("./manageAccount/ManageAccountsList")),
    },
];

export default configurationRoutes;
